import { Box, Pagination, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import DummyPostCard from "../Components/DummyPostCard";
import PostCard from "../Components/PostCard";
import { useQueryGetPosts } from "../api/useQueryGetPosts";
import { PostCollection } from "../interfaces/IPost";

const PostList: React.FC = () => {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [posts, setPosts] = useState<PostCollection>();
  const params = useParams();
  const scrollRef = useRef<any>();
  const category = params.slug ?? "";
  const {
    data: postData,
    isLoading,
    isSuccess,
  } = useQueryGetPosts({ page: page, limit: limit, category: category });
  useEffect(() => {
    if (postData && !isLoading && isSuccess) {
      const { posts } = postData;
      setPosts(posts);
      setPage(posts.current_page);
      setTotal(posts.last_page);
    }
    if (page > 1) {
      scrollRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [postData, isLoading, isSuccess]);

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <Box ref={scrollRef}>
      <Box>
        <Typography variant="h5" color="primary">
          What is Bookmarking? 100+ Social Bookmarking Sites List 2023
        </Typography>
        submission in SEO refers to the practice of submitting website URLs to
        social bookmarking websites. It helps to increase website visibility and
        generate backlinks. By bookmarking a webpage on high-quality bookmarking
        sites, it can attract more visitors, improve search engine rankings, and
        enhance overall online presence.
      </Box>
      <Box className="mt-4 w-full">
        {isLoading && [1, 2].map((item) => <DummyPostCard key={item} />)}
        {!isLoading &&
          posts &&
          posts?.data.length > 0 &&
          posts?.data.map((post) => <PostCard key={post.id} data={post} />)}
      </Box>
      {posts && posts?.total > 0 && (
        <Box className="p-2 pt-4 flex justify-end">
          <Pagination
            size="small"
            count={total}
            page={page}
            onChange={handleChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default PostList;
